"use strict";

angular.module("models").service("SchedulesService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("schedules", [], function (element) {
    return "?.?";
  }));
}]);